export default{

    suggestions : ["20", "50", "70"],
    clock : '30:00'
}